import { useConfig } from './use-config';

export function useHelmetTitle(prefix: (string | null | undefined)[]): string {
  const instanceName = useConfig('appName');
  const base = [instanceName ?? '', 'Yarmill'];

  return prefix.concat(base).filter(Boolean).join(' | ');
}
